export const initialState = {
  loading: true,
  photos: [],
  count: 0,
  error: null
};

export const photoReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_PHOTOS": {
      return {
        loading: true,
        photos: [],
        count: 0,
        error: null
      };
    }
    case "PHOTOS_LOADED": {
      return {
        loading: false,
        photos: action.payload.items,
        count: action.payload.count,
        error: null
      };
    }
    case "LOAD_MORE_PHOTOS": {
      return {
        loading: false,
        photos: [...state.photos, ...action.payload],
        count: state.count,
        error: null
      };
    }
    case "PHOTOS_ERROR": {
      return {
        loading: false,
        photos: [],
        count: 0,
        error: true
      };
    }

    default:
      throw new Error("Не тот экшен");
  }
};
